import { render } from "./LsaTrend.vue?vue&type=template&id=002331b0"
import script from "./LsaTrend.vue?vue&type=script&lang=js"
export * from "./LsaTrend.vue?vue&type=script&lang=js"

import exportComponent from "/builds/benoit67/django-business-center-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__